import { Button, Dialog, DialogActions, DialogContent } from "@mui/material";
import { useTranslation } from "react-i18next";
import BootstrapDialogTitle from "../../../components/BootstrapDialogTitle";
import styles from "./TaskDialogs.module.scss";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useNavigate } from "react-router";
import { ReactNode } from "react";

interface Props {
  open: boolean;
  onAccept: () => void;
  onClose: () => void;
  className?: string | undefined;
  saving?: boolean;
}

export const CancelDialog: React.FC<Props> = (props: Props) => {
  const { t } = useTranslation();

  return <ConfirmDialog {...props} title={t("cancelWarning")!} text={t("areYouSureYouWantToCancel")} />;
};

export const ConfirmDialog: React.FC<Props & { title?: string | undefined; text: string }> = ({
  open,
  title,
  text,
  onAccept,
  onClose,
  className,
  saving,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog className={`${styles.cancelDialog} ${className ?? ""}`} open={open} fullWidth maxWidth="sm">
      <BootstrapDialogTitle onClose={onClose}>{title}</BootstrapDialogTitle>
      <DialogContent>
        <p>{text}</p>
      </DialogContent>
      <DialogActions>
        <Button className={styles.yes} variant="contained" onClick={() => onAccept()} disabled={saving}>
          {t("yes")}
        </Button>
        <Button className={styles.no} variant="contained" onClick={() => onClose()} disabled={saving}>
          {t("no")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export const SaveSuccessDialog: React.FC<Props & { title: string; icon?: ReactNode | undefined }> = ({
  open,
  onAccept,
  onClose,
  title,
  icon,
  className,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Dialog className={`${styles.saveSuccessDialog} ${className ?? ""}`} open={open} fullWidth maxWidth="md">
      <DialogContent>
        <p>{title}</p>
        {icon ?? <CheckCircleIcon />}
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={() => navigate("/")}>
          {t("backToHome")}
        </Button>
        <Button variant="text" onClick={() => navigate("/mytasks")}>
          {t("goToMyTasks")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
